import React from 'react';
import { Button } from "react-bootstrap";

export default function ModalCloseButton({ onClick }) {
    return (
        <Button className="btn-modal-close" onClick={onClick} variant="outline-dark">
            <i className="fas fa-times"></i>
        </Button>
    );
}